<template>
  <ABadge class="bg-brand-compliment text-brand">
    <template #icon>
      <Icon height="16" width="16" class="mr-1" />
    </template>
    <span class="font-bold" style="font-size: 12px">48h </span>
    <span>{{ $t('badges.delivery') }}</span>
  </ABadge>
</template>

<script>
import ABadge from '../ABadge.vue'
import Icon from '../icons/DeliveryClock.vue'

export default {
  components: {
    ABadge,
    Icon,
  },
}
</script>
